import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { InlineSVGModule } from 'ng-inline-svg-2';
import { AlertService } from '../../../../../../core/services/alert.service';
import { WizardStepsService } from '../../../../../../core/services/wizard-steps.service';
import { VerificationCodeComponent } from '../../../../../../shared/modules/inputs/components/verification-code/verification-code.component';
import { AuthService } from '../../../services/auth.service';
import { ForgetPasswordStepService } from '../../../services/forget-password-step.service';
import { SharedModule } from '../../../../../../shared/shared-module';

@Component({
  selector: 'app-forget-password-step-2',
  templateUrl: './forget-password-step-2.component.html',
  styleUrl: './forget-password-step-2.component.scss',
  imports: [VerificationCodeComponent, SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgetPasswordStep2Component {
  constructor(
    public wizardStepsService: WizardStepsService,
    private authService: AuthService,
    private alertService: AlertService,
    public forgetPasswordStepService: ForgetPasswordStepService,
  ) {}

  async submit(code: string) {
    const res = await this.authService.verifyResetPasswordCode({
      email: this.forgetPasswordStepService.email,
      code,
    });
    this.forgetPasswordStepService.email = this.forgetPasswordStepService.email;
    this.forgetPasswordStepService.code = code;
    this.alertService.suucess(res.message);
    this.wizardStepsService.moveToNextStep();
  }

  async resendCode() {
    const res = await this.authService.resetPasswordResendCode({
      email: this.forgetPasswordStepService.email,
    });
    this.forgetPasswordStepService.email = this.forgetPasswordStepService.email;
    this.alertService.suucess(res.message);
  }
}
